














import {Component, Prop, Vue} from 'vue-property-decorator';
import BigIconPanel from '@/modules/neodash/components/big-icon-panel/big-icon-panel.vue';

@Component({
  name: 'ReportPlaceHolder',
  components: {
    BigIconPanel
  }
})
export default class ReportPlaceHolder extends Vue {
  @Prop({required: true})
  public showPlaceHolder: Boolean;
}
